<script>
import RecognitionDemo from './RecognitionDemo'

export default {
    name: 'IDRecognitionDemo',
    extends: RecognitionDemo,
    data () {
        let fieldList = [
            { name: 'name', label: this.$t('name') },
            { name: 'id', label: this.$t('number') },
            { name: 'dob', label: this.$t('dateOfBirth') },
            { name: 'sex', label: this.$t('gender') },
            { name: 'address', label: this.$t('address') }
        ]
        for (let field of fieldList) {
            field.label = this.$filters.capitalize(field.label)
        }
        return {
            model: {
                name: 'NGUYỄN VĂN A',
                id: '0123456789',
                sex: 'N/A',
                dob: '01/02/1973',
                address: 'CẦU GIẤY, HÀ NỘI',
                nationality: 'N/A',
                issueDate: '',
                doe: '',
                type_new: '',
                ethnicity: '',
                issue_date: '',
                religion: '',
                issue_loc: ''
            },
            imageUrl: '/static/img/cmt.jpg',
            demoUrl: process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_ID_RECOGNITION,
            fieldList: fieldList
        }
    }
}
</script>
